import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { connect } from "react-redux";
import { getValue } from "../Reducers/reducer";
import { setValue } from "../Reducers/actions";
import RolloutsPrice from "./RolloutsPrice";
import Form from "../Form";

const style = {
  box: {
    display: "flex",
    marginBottom: 13
  },
  boxRollouts: {
    extend: "box",
    backgroundColor: "#FFFFFF",
    height: 165,
    borderTop: "3px solid #0E283D",
    border: "1px solid #F2F2F2",
    borderRadius: "0 0 3px 3px",
    width: 369,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginRight: 31
  },
  textRollouts: {
    width: 70,
    marginTop: 26,
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 16,
    textAlign: "right"
  },
  textDevice: {
    extend: "textRollouts",
    width: 80,
    marginRight: 6
  },
  boxValues: {
    display: "flex"
  }
};

const Rollouts = ({
  classes,
  objectValue,
  onChangeRollout,
  onChangePercentual
}) => {
  const rollout = objectValue.rollout;
  const rolloutPrice = objectValue.rolloutPrice;
  const transferPrice = objectValue.transferPrice;
  let deviceUpdate = (objectValue.device * objectValue.percentualDevice) / 100;
  const props = { deviceUpdate, rolloutPrice, transferPrice, rollout };

  return (
    <div className={classes.box}>
      <div className={classes.boxRollouts}>
        <div className={classes.boxValues}>
          <div className={classes.textRollouts}>Update rollouts</div>
          <Form value={rollout} onChange={onChangeRollout} text={""} />
        </div>
        <div className={classes.boxValues}>
          <div className={classes.textDevice}>Devices included</div>
          <Form
            value={objectValue.percentualDevice}
            onChange={onChangePercentual}
            text={"%"}
          />
        </div>
      </div>
      <RolloutsPrice {...props} />
    </div>
  );
};

Rollouts.propTypes = {
  classes: PropTypes.object.isRequired,
  objectValue: PropTypes.object.isRequired,
  onChangeRollout: PropTypes.func.isRequired,
  onChangePercentual: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  objectValue: getValue(state)
});

const mapDispatchToProps = {
  setValue
};

const mergeProps = (state, actions, props) => {
  return {
    ...state,
    onChangeRollout(total) {
      actions.setValue({
        device: state.objectValue.device,
        updateSize: state.objectValue.updateSize,
        rollout: total,
        percentualDevice: state.objectValue.percentualDevice
      });
    },
    onChangePercentual(total) {
      actions.setValue({
        device: state.objectValue.device,
        updateSize: state.objectValue.updateSize,
        rollout: state.objectValue.rollout,
        percentualDevice: total
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(injectSheet(style)(Rollouts));
